import { NavItemType } from 'types';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import ERoutes from 'routes/ERoutes';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';

const system: NavItemType = {
    id: 'system',
    title: 'System',
    icon: MonitorHeartIcon,
    type: 'group',
    // Gate the whole System group so Customer Service never sees the menu; the
    // sidebar only hides a top-level group when the group itself carries `roles`.
    roles: ['superAdmin', 'developer'],
    url: ERoutes.queueMonitor,
    children: [
        {
            id: 'queue-monitor',
            title: 'Queue monitor',
            type: 'item',
            icon: MonitorHeartIcon,
            url: ERoutes.queueMonitor,
            roles: ['superAdmin', 'developer'],
            breadcrumbs: false
        },
        {
            id: 'feature-flags',
            title: 'Feature Flags',
            type: 'item',
            icon: ToggleOnIcon,
            url: '/system/feature-flags',
            roles: ['superAdmin', 'developer'],
            breadcrumbs: false
        },
        {
            id: 'email-deliverability',
            title: 'Email deliverability',
            type: 'item',
            icon: MarkEmailReadIcon,
            url: ERoutes.emailDeliverability,
            roles: ['superAdmin', 'developer'],
            breadcrumbs: false
        }
    ]
};

export default system;
